import {useMatchMedia} from '@pexip/hooks';

import {SM} from '../../constants/mediaQueries';

export const useSm = () => useMatchMedia(SM);
